import React from "react";

// Business domain, with the map listing / LSA / seller name underneath.
export default function BusinessCell({ c }) {
  return (
    <div className="min-w-0">
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="truncate">{c.name}</span>
        {c.likely && <span title="Matched by business name, as the listing has no readable website. Worth a quick check." className="flex-shrink-0 text-[0.625rem] font-semibold uppercase tracking-wide bg-slate-100 text-slate-500 px-1.5 py-0.5 rounded">likely match</span>}
      </div>
      {c.businessNames.length > 0 && <p className="text-[0.6875rem] font-normal text-slate-400 truncate mt-0.5">{c.businessNames.join(" · ")}</p>}
    </div>
  );
}
